module.exports = __webpack_public_path__ + "img/10_Instaöllation-Tabelle.2aca6e59.svg";